import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const DropDownVocabulary = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  optionsVersion = [],
  disabled = false,
}) => {
  const { t } = useTranslation();

  const combinedOptions = useMemo(() => {
    const collator = new Intl.Collator(undefined, {
      sensitivity: "base",
      numeric: true,
    });

    return options
      .map((option, index) => ({
        label: option,
        value: optionsValue[index],
        version: optionsVersion[index],
      }))
      .sort((a, b) =>
        collator.compare(String(a?.label ?? ""), String(b?.label ?? "")),
      );
  }, [options, optionsValue, optionsVersion]);

  const selectedOption =
    combinedOptions.find((opt) => opt.value === value) || null;

  const typographyBodySm = {
    fontSize: "14px",
    fontWeight: 400,
    letterSpacing: "0.28px",
    lineHeight: "24px",
  };

  const textDropdownColor = "rgba(7, 15, 38, 1)";
  const backgroundDropdown = "rgba(255, 255, 255, 1)";
  const borderDropdownColor = "rgba(46, 64, 77, 1)";

  return (
    <Box className="dropdownButtons">
      <Autocomplete
        id="vocabulary-autocomplete"
        size="small"
        fullWidth
        disabled={disabled}
        options={combinedOptions}
        getOptionLabel={(option) => option.label || ""}
        value={selectedOption}
        onChange={(event, newValue) => {
          const fakeEvent = {
            target: {
              value: newValue ? newValue.value : "",
            },
          };
          onChange(fakeEvent);
        }}
        popupIcon={<KeyboardArrowDownIcon />}
        sx={{
          "& .MuiOutlinedInput-root": {
            ...typographyBodySm,
            height: 44,
            padding: "0 14px !important",
            color: disabled ? "rgba(0, 0, 0, 0.38)" : textDropdownColor,
            backgroundColor: disabled ? "#e8e8e8" : backgroundDropdown,
            "& fieldset": {
              borderColor: disabled
                ? "rgba(0, 0, 0, 0.2)"
                : borderDropdownColor,
            },
            "&:hover fieldset": {
              borderColor: borderDropdownColor,
            },
            "&.Mui-focused fieldset": {
              borderColor: borderDropdownColor,
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("dropdown.vocab")}
            sx={{
              "& .MuiInputBase-input::placeholder": {
                color: textDropdownColor,
              },
            }}
          />
        )}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;
          return (
            <li
              key={key}
              {...otherProps}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={typographyBodySm}>{option.label}</span>

              {option.version && (
                <Typography
                  component="span"
                  sx={{ ml: 1, fontSize: "12px", color: "rgba(0,0,0,0.5)" }}
                >
                  v{option.version}
                </Typography>
              )}
            </li>
          );
        }}
      />
    </Box>
  );
};

export default DropDownVocabulary;
